var map = {
	"./blocks/custom/accordion/block.js": 4880,
	"./blocks/custom/cases/block.js": 7015,
	"./blocks/custom/category/block.js": 9032,
	"./blocks/custom/header/block.js": 6329,
	"./blocks/custom/imageHeader/block.js": 2906,
	"./blocks/custom/logoSlider/block.js": 1726,
	"./blocks/custom/slider/block.js": 8645,
	"./blocks/custom/textImageHeader/block.js": 6099,
	"./blocks/custom/videoHeader/block.js": 1088,
	"./blocks/custom/videoHeaderOrImage/block.js": 9332,
	"./blocks/custom/videoWithPlaceholder/block.js": 1032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9363;